import * as actionTypes from 'constants/ActionTypes';

const cargoAssigners = (state = {
    items: [],
    errors: [],
    isLoaded: false,
    searchText: '',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_ASSIGNERS.REQUEST:
        return {
            ...state,
            items: [],
            errors: [],
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_ASSIGNERS.SUCCESS: {
        const items = action.data.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
            isSuggest: false,
        }));

        return {
            ...state,
            items,
            errors: [],
            isLoaded: true,
        };
    }
    case actionTypes.GET_CARGO_ASSIGNERS.FAILURE:
        return {
            ...state,
            errors: action.errors,
            isLoaded: true,
        };

    case actionTypes.GET_CARGO_ASSIGNERS_POST.REQUEST:
        return {
            ...state,
        };
    case actionTypes.GET_CARGO_ASSIGNERS_POST.SUCCESS: {
        const items = action.data.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
            isSuggest: false,
        }));

        return {
            ...state,
            items,
            errors: [],
            isLoaded: true,
        };
    }
    case actionTypes.GET_CARGO_ASSIGNERS_POST.FAILURE:
        return {
            ...state,
            errors: action.errors,
            isLoaded: true,
        };

    case actionTypes.UPDATE_CARGO_ASSIGNER.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_CARGO_ASSIGNER.SUCCESS: {
        let { items } = state;

        items = items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: false,
                    isSuggest: false,
                    lastModify: {
                        date: action.item.lastModify.date,
                        user: action.item.lastModify.user,
                    },
                    prevState: action.item,
                };
            }
            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_CARGO_ASSIGNER.FAILURE: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: true,
                    isSuggest: false,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    }

    case actionTypes.SAVE_STATUS_CARGO_ASSIGNER: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: action.item.isUpdate,
                    isSuggest: action.item.isSuggest,
                };
            }
            return item;
        });

        return {
            ...state,
            items,
        };
    }
    
    case actionTypes.SEARCH_CARGO_ASSIGNERS:
        return {
            ...state,
            searchText: action.search,
        };
        
    default:
        return state;
    }
};

export default cargoAssigners;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/assigners.js